module.exports = __webpack_public_path__ + "static/img/KANBAN_OUI.fadac3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/KANBAN_OUI.png
// module id = NJcE
// module chunks = 1